<template>
    <div class="breadcrumbs">
        <ul itemscope itemtype="https://schema.org/BreadcrumbList">
            <li itemprop="itemListElement" itemscope
                 itemtype="https://schema.org/ListItem" v-bind:key="index" v-for="(page, index) in path">
                <a itemprop="item" itemtype="https://schema.org/Service" class="" @click="goToPage(page)">
                    <span itemprop="name">{{ page.meta.title }}</span>
                    <meta itemprop="position" :content="index" />
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: "BreadcrumbComponent",
        computed: {
            routeCollection() {
                return this.$router.options.routes;
            },
            primaryRoute() {
              if(!this.routeCollection)  return;

              return this.routeCollection.find(item => {
                  return item.meta['isPrimary'] === true
              })
            },
            path() {
                let current =  this.$route;

                if(!current.name || current.name.length <= 0) {
                    return null;
                }

                let parts = current.name.split('.');

                if(!parts) {
                    return null;
                }

                if(parts.length === 0 || parts.length === 1) {
                    parts.push(current.meta['title'])
                }

                let fullPath = [
                    this.primaryRoute
                ];


                let first = true;
                parts.forEach((item, index) => {
                    let part = this.routeCollection.find(route => {
                        return route.name === this.combinePreviousParts(parts, index)
                    });

                    if(part) {
                        fullPath.push(part);
                    }

                    if (first) first = false;
                });

                return fullPath;
            }
        },
        methods: {
            goToPage(page) {
                if (this.$route.path === page.path) return;

                if(page.path === '/hosting') return;

                return this.$router.push(page.path)
            },
            combinePreviousParts(collection, currentIndex, objProp = null, separator = ".") {
                let final = "";

                collection.forEach((item, index) => {
                    if (index > (currentIndex)) return;

                    if (!objProp) {
                        final += item.concat(separator);
                    } else {
                        final += item[objProp].concat(separator);
                    }

                });

                if (final.length > 0) {
                    final = final.substr(0, final.length - 1);
                }

                return final;
            }
        }
    }
</script>

<style scoped lang="scss">
    $breadcrumb-inactive-item-color: #999999;
    $breadcrumb-active-color: #fefefe;
    $breadcrumb-separator-color: #fefefe;

    .breadcrumbs {
        position: absolute;
        bottom: 10px;

        ul {
            list-style: none;
            padding: 0;

            li {
                &:not(:last-child) {
                    margin-right: 4px;
                }

                display: inline-block;
                position: relative;
                color: $breadcrumb-inactive-item-color;

                &:not(:last-child) {
                    padding-right: 12px;

                    &:after {
                        content: ">";
                        position: absolute;
                        right: 0;
                        color: $breadcrumb-separator-color;
                    }
                }

                &:last-child {
                    color: $breadcrumb-active-color;
                }
            }
        }
    }
</style>